import map from 'lodash/map'
import React, { useContext, useMemo, useState, VFC } from 'react'

import { LinkedProductParentIDContext } from '@Components/Product/Linked/LinkedProductList'
import { LinkedProduct } from '@Globals/CMS/ProductHelpers'
import { useTranslation } from '@Globals/Translations'

import { LinkedProductsRoot, LinkedProductTitle } from './LinkedProduct.styled'
import { LinkedProductItem } from './LinkedProductItem'

interface LinkedProductVariantProps {
  products: LinkedProduct[]
  type: string
}

export const LinkedProducts: VFC<LinkedProductVariantProps> = ({ products, type }) => {
  const { t } = useTranslation()
  const defaultTitle = useMemo(() => {
    if (type === 'color') {
      return t('products:COLOURS_LABEL')
    }

    if (type === 'size') {
      return t('products:SIZES')
    }

    if (type === 'variation') {
      return t('products:VARIATIONS')
    }

    return type
  }, [t, type])
  const [title, setTitle] = useState(defaultTitle)
  const currentlySelectedID = useContext(LinkedProductParentIDContext)

  return (
    <LinkedProductsRoot key={type}>
      <LinkedProductTitle>{title}</LinkedProductTitle>
      {map(products, product => (
        <LinkedProductItem
          key={product.url}
          image={product.image}
          isSelected={currentlySelectedID === product.productID}
          productID={product.productID}
          setTitle={newTitle => setTitle(newTitle || defaultTitle)}
          title={product.title}
          type={type}
          url={product.url}
        />
      ))}
    </LinkedProductsRoot>
  )
}

